import React from 'react';
import { skillGroups } from '../data/profile';

const Skills = () => {
  return (
    <section id="skills" className="section">
      <div className="container">
        <header className="section-head">
          <p className="eyebrow">Skills</p>
          <h2>The stack I actually use.</h2>
          <p className="lede">
            Grouped the way a hiring manager scans a CV: languages, frameworks, data, delivery, and the engineering habits underneath.
          </p>
        </header>
        <div className="skill-grid">
          {skillGroups.map((group) => (
            <article className="skill-group" key={group.title}>
              <h3>{group.title}</h3>
              <div className="chip-row">
                {group.items.map((item) => (
                  <span className="chip quiet" key={item}>
                    {item}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
